import { Injectable } from '@angular/core';

//Services
import { AjaxService } from "app/services/ajax";

//Interfaces
import { Pessoa, Observacao } from "app/interfaces";


@Injectable()
export class PessoasService {

  constructor(private ajax: AjaxService) { }

  getUrl() {
    return this.ajax.getUrl();
  }

  getData(consulta?): Promise<Pessoa[]> {
    return new Promise((resolve, reject) => {
      this.ajax.get('/pessoas', consulta).then((data) => {
        resolve(data);
      }).catch((error) => {
        this.alertError();
        console.log(error);
      });
    });
  }

  getLista(consulta?): Promise<Pessoa[]> {
    return new Promise((resolve, reject) => {
      this.ajax.get('/pessoas/lista', consulta).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
        console.log(error);
      });
    });
  }

  getListaGuias(consulta?): Promise<Pessoa[]> {
    return new Promise((resolve, reject) => {
      this.ajax.get('/pessoas/lista/guias', consulta).then((data) => {
        resolve(data);
      }).catch((error) => {
        reject(error);
        console.log(error);
      });
    });
  }

  postData(dados): Promise<Pessoa> {
    return new Promise((resolve, reject) => {
      this.ajax.post('/pessoas', dados).then((data) => {
        resolve(data);
      }).catch((error) => {
        this.alertError();
        console.log(error);
      });
    });
  }

  putData(dados): Promise<Pessoa> {
    let id = dados.id;
    delete dados.id;
    return new Promise((resolve, reject) => {
      this.ajax.put('/pessoas/' + id, dados).then((data) => {
        resolve(data);
      }).catch((error) => {
        this.alertError();
        console.log(error);
      });
    });
  }

  remove(id): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.ajax.delete('/pessoas', id).then((resposta) => {
        resolve(resposta);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  postObservacao(dados): Promise<Observacao> {
    return new Promise((resolve, reject) => {
      let pessoa_id = dados.pessoa_id;
      delete dados.pessoa_id;
      this.ajax.post('/pessoas/' + pessoa_id + '/observacao', dados).then((data) => {
        resolve(data);
      }).catch((error) => {
        this.alertError();
        console.log(error);
      });
    });
  }

  putObservacao(dados): Promise<Observacao> {
    return new Promise((resolve, reject) => {
      let id = dados.id;
      delete dados.id;

      this.ajax.put('/pessoas/observacao/' + id, dados).then((data) => {
        resolve(data);
      }).catch((error) => {
        this.alertError();
        console.log(error);
      });
    });
  }

  deleteObservacao(id): Promise<Boolean> {
    return new Promise((resolve, reject) => {
      this.ajax.delete('/pessoas/observacao', id).then((resposta) => {
        resolve(resposta);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  putTipoFuncional(dados): Promise<Pessoa> {
    let id = dados.pessoa_id;
    delete dados.pessoa_id;
    return new Promise((resolve, reject) => {
      this.ajax.put('/pessoas/' + id + '/tiposFuncionais', dados).then((data) => {
        resolve(data);
      }).catch((error) => {
        this.alertError();
        console.log(error);
      });
    });
  }

  putDetalhesTipoFuncional(dados): Promise<Pessoa> {
    let id = dados.pessoa_id;
    delete dados.pessoa_id;

    return new Promise((resolve, reject) => {
      this.ajax.put('/pessoas/' + id + '/detalhesTipoFuncional', dados).then((data) => {
        resolve(data);
      }).catch((error) => {
        this.alertError();
        console.log(error);
      });
    });
  }

  removePessoaCondicao(id): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.ajax.delete('/pessoas/promocao_condicao', id).then((resposta) => {
        resolve(resposta);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  alertError(): void {
    alert('Erro processando os dados.');
  }
}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/pessoas/pessoas.service.ts